import React from "react";
import axios from "axios";
import { useFormik } from "formik";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { backendServerBaseURL } from "../../utils/backendServerBaseURL";
import { Form, FormikProvider } from "formik";
import { Helmet } from "react-helmet-async";

export default function ChangePassword() {
  const params = useParams();
  const navigate = useNavigate();
  // const [showPassword, setShowPassword] = useState(false);
  const [passwordHide, setpasswordHide] = useState(true);
  const [passwordHide2, setpasswordHide2] = useState(true);

  const handlePasswordShow = () => {
    setpasswordHide(!passwordHide);
  };
  const handlePasswordShow2 = () => {
    setpasswordHide2(!passwordHide2);
  };

  const ValidationSchema = Yup.object().shape({
    newPassword: Yup.string().required("New Password is required").min(8, "Password must contain at least 8 letters"),
    confirmpassword: Yup.string()
      .required("Please retype your password.")
      .oneOf([Yup.ref("newPassword")], "Passwords must match"),
  });

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmpassword: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      setSubmitting(true);

      await axios
        .patch(`${backendServerBaseURL}/auth/forgot-password`, {
          newPassword: values["newPassword"],
          resetPasswordToken: params.resetPasswordToken,
        })
        .then((response) => {
          setSubmitting(false);
          console.log(response.data.data);
          if (response.status === 200 && response.data.message === "Password updated successfully") {
            navigate(`/password-changed-successfully`);
          }
        })
        .catch((error) => {
          setSubmitting(false);
          try {
            console.log(error);
            if (error.response.status === 400) {
              setErrors({ afterSubmit: error.response.data.message });
            }
          } catch (e) {
            console.log(e);
          }
        });
    },
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <>
      <Helmet>
        <title>Change Password - LightningProxies</title>
      </Helmet>
      <section class="auth-section text-start ">
        <div class="container-fluid">
          <div class="row justify-content-center align-items-center">
            <div class="col-12">
              <div class="auth-logo-wrap">
                <a href="#">
                  <img src="/assets/images/logo.svg" alt="Logo" class="img-fluid" />
                </a>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-center">
              <div class="signup-form-wrap">
                <h1>Reset Password</h1>
                <p>Create a new unique password</p>

                <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <div class="form-group">
                      <label for="">New Password</label>
                      <input
                        type={passwordHide ? "password" : "text"}
                        placeholder="Create password"
                        class="form-control"
                        id="password-field"
                        {...getFieldProps("newPassword")}
                      />
                      <i
                        class={passwordHide ? "fa fa-eye" : "fa fa-eye-slash"}
                        onClick={() => handlePasswordShow()}
                        id="eye-click"
                      ></i>
                      <span
                        className="invalid-feedback"
                        style={{
                          display: Boolean(touched.newPassword && errors.newPassword) ? "block" : "none",
                        }}
                      >
                        {errors.newPassword}
                      </span>
                    </div>
                    <div class="form-group">
                      <label for="">Confirm New Password</label>
                      <input
                        type={passwordHide2 ? "password" : "text"}
                        placeholder="Confirm New Password"
                        {...getFieldProps("confirmpassword")}
                        class="form-control"
                        id="password-confirm"
                      />
                      <i
                        class={passwordHide2 ? "fa fa-eye" : "fa fa-eye-slash"}
                        onClick={() => handlePasswordShow2()}
                        id="eye-click"
                      ></i>
                      <span
                        className="invalid-feedback"
                        style={{
                          display: Boolean(touched.confirmpassword && errors.confirmpassword) ? "block" : "none",
                        }}
                      >
                        {errors.confirmpassword}
                      </span>
                    </div>
                    <div class="submit-bttn mb-5">
                      <button type="submit" class="btn btn-submit">
                        Confirm New Password
                      </button>
                    </div>
                    {/* Errors from server */}
                    {errors.afterSubmit && (
                      <div className="alert alert-danger mb-5" role="alert">
                        {errors.afterSubmit}
                      </div>
                    )}
                  </Form>
                </FormikProvider>
                <div class="signup-bttm-txt  text-center">
                  <p>
                    Facing Issues? <a href="#">Contact Support</a>
                  </p>
                </div>

                <div class="credential-ftr-txt">
                  <p>&copy; 2023 Lightning Proxies. All rights reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
    // <>
    //   <Helmet>
    //     <title>Change Password - LightningProxies</title>
    //   </Helmet>

    //   {/* ========== MAIN CONTENT ========== */}
    //   <main
    //     id="content"
    //     role="main"
    //     className="main"
    //     style={{ fontFamily: "Inter, sans-serif" }}
    //   >
    //     <div
    //       className="position-fixed top-0 end-0 start-0 bg-img-start"
    //       style={{
    //         height: "32rem",
    //         backgroundImage: "url(/static/svg/components/card-6.svg)",
    //       }}
    //     >
    //       {/* Shape */}
    //       <div className="shape shape-bottom zi-1">
    //         <svg
    //           preserveAspectRatio="none"
    //           xmlns="http://www.w3.org/2000/svg"
    //           x="0px"
    //           y="0px"
    //           viewBox="0 0 1921 273"
    //         >
    //           <polygon fill="#fff" points="0,273 1921,273 1921,0 " />
    //         </svg>
    //       </div>
    //       {/* End Shape */}
    //     </div>
    //     {/* Content */}
    //     <FormikProvider value={formik}>
    //       <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
    //         <div className="container py-5 py-sm-7">
    //           <a className="d-flex justify-content-center mb-5" href="/">
    //             <img
    //               className="zi-2"
    //               src="/logo.svg"
    //               alt="Image Description"
    //               style={{ maxHeight: "3rem" }}
    //             />
    //           </a>
    //           <div className="mx-auto" style={{ maxWidth: "30rem" }}>
    //             {/* Card */}
    //             <div className="card card-lg mb-5">
    //               <div className="card-body">
    //                 {/* Form */}

    //                 <div className="text-center">
    //                   <div className="mb-5">
    //                     <h1 className="display-5">Change Password</h1>
    //                     <p>Enter your new password</p>
    //                   </div>
    //                 </div>

    //                 {/* New Password */}
    //                 <div className="mb-4">
    //                   <label className="form-label">New Password</label>
    //                   <input
    //                     {...getFieldProps("newPassword")}
    //                     className="form-control form-control-lg"
    //                     placeholder="Enter your new password here"
    //                   />
    //                   <span
    //                     className="invalid-feedback"
    //                     style={{
    //                       display: Boolean(
    //                         touched.newPassword && errors.newPassword
    //                       )
    //                         ? "block"
    //                         : "none",
    //                     }}
    //                   >
    //                     {errors.newPassword}
    //                   </span>
    //                 </div>

    //                 {/* Errors from server */}
    //                 {errors.afterSubmit && (
    //                   <div className="alert alert-danger" role="alert">
    //                     {errors.afterSubmit}
    //                   </div>
    //                 )}

    //                 <div className="d-grid gap-2">
    //                   <button type="submit" className="btn btn-primary ">
    //                     Submit
    //                   </button>
    //                   <div className="text-center">
    //                     <a className="btn btn-link" href="/login">
    //                       <i className="bi-chevron-left" /> Back to Sign in
    //                     </a>
    //                   </div>
    //                 </div>

    //                 {/* End Form */}
    //               </div>
    //             </div>
    //             {/* End Card */}
    //           </div>
    //         </div>
    //       </Form>
    //     </FormikProvider>
    //     {/* End Content */}
    //   </main>
    //   {/* ========== END MAIN CONTENT ========== */}
    // </>
  );
}
